import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=6a555e08&"
import script from "./CompanySettings.vue?vue&type=script&lang=js&"
export * from "./CompanySettings.vue?vue&type=script&lang=js&"
import style0 from "./CompanySettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports